import { render, staticRenderFns } from "./LinkComponent.vue?vue&type=template&id=530e0502"
import script from "./LinkComponent.vue?vue&type=script&lang=js"
export * from "./LinkComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530e0502')) {
      api.createRecord('530e0502', component.options)
    } else {
      api.reload('530e0502', component.options)
    }
    module.hot.accept("./LinkComponent.vue?vue&type=template&id=530e0502", function () {
      api.rerender('530e0502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stores/Editor/Components/LinkComponent.vue"
export default component.exports